import {
  type IconElement,
  IconFileSpreadsheet,
  SingleUpload,
  type UploadFile,
  type UploaderFile,
  renderIcon,
} from '@procurify/ui'

import { ATTACHMENTS_URL } from '@webapp/api/AttachmentsAPI'
import { useFormatMedia } from '@webapp/core/hooks/useFormatMedia'
import { formatMbToBytes } from '@webapp/core/utils/formatMbToBytes'
import { useProcurifyIntl } from '@webapp/hooks'
import { ImporterUploaderStyled } from './styles/ImporterUploaderStyled'
import messages from '../../messages'
import { ImporterUploaderContentStyled } from '../../styles/ImporterUploaderContentStyled'

const MAX_FILE_MB = 25

export interface IImporterUploaderProps {
  id?: string
  icon?: IconElement
  endpoint?: string
  onFileRemove?: () => void
  onFileAdded?: () => void
  onUpload?: (file: UploaderFile) => void
  validFileTypes?: string[]
  validFileTypeName?: string
}

export const ImporterUploader = ({
  id,
  icon = <IconFileSpreadsheet />,
  endpoint = ATTACHMENTS_URL,
  onFileRemove = () => undefined,
  onFileAdded = () => undefined,
  onUpload,
  validFileTypes = [],
  validFileTypeName,
}: IImporterUploaderProps) => {
  const intl = useProcurifyIntl()
  const formatMedia = useFormatMedia()

  const onUploadSuccess = (files: UploadFile[]) => {
    const [file] = files

    if (onUpload) {
      onUpload(file)
    }
  }

  const getUploadUrl = (res) => {
    return res?.data?.file ? formatMedia(res.data.file) : ''
  }

  return (
    <ImporterUploaderStyled>
      <ImporterUploaderContentStyled>
        {renderIcon(icon, { size: 60 })}

        <SingleUpload
          id={id}
          endpoint={endpoint}
          onDelete={onFileRemove}
          onBatchComplete={onUploadSuccess}
          getFileUrl={getUploadUrl}
          maxFileSize={formatMbToBytes(MAX_FILE_MB)}
          onFileAdd={onFileAdded}
          allowedFileTypes={validFileTypes}
          strings={{
            exceedsSizeLimit: intl.formatMessage(messages.fileSizeExceeded, {
              maxFileSize: MAX_FILE_MB,
            }),
            unacceptedFileType: intl.formatMessage(messages.wrongFileType, {
              fileTypeName: validFileTypeName,
            }),
          }}
        />
      </ImporterUploaderContentStyled>
    </ImporterUploaderStyled>
  )
}

ImporterUploader.displayName = 'ImporterUploader'
